"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.byPayloadUuid = exports.byPayloadId = exports.byId = void 0;
var byId = function (id) { return function (thing) {
    return id === thing.id;
}; };
exports.byId = byId;
var byPayloadId = function (id) { return function (thing) { return id === thing.payload.id; }; };
exports.byPayloadId = byPayloadId;
var byPayloadUuid = function (uuid) { return function (thing) { return uuid === thing.payload.uuid; }; };
exports.byPayloadUuid = byPayloadUuid;
